import axios from "axios";
import API from "./API";
import Endpoints from "@/V3/Config/Endpoints";

export default {
    listWithoutCommsRoom: function (centreId) {
        return axios.get(
            API.url(Endpoints.InventoryGroups.ListWithoutCoomsRoom, {centre_id: centreId})
        ).then((res) => {
            return res.data.inventoryGroups;
        });
    }
}
